const filtersQueryStringMixin = {
  // components should declare its filter to enable parsing and updating query string
  watch: {
    '$route.query': {
      handler() {
        this.parsefilterFromQueryString();
      },
    },
    filter: {
      handler() {
        this.updatefilterInQueryString();
      },
      deep: true,
    },
    keyword: {
      handler() {
        this.updatefilterInQueryString();
      },
      deep: true,
    },
    dateRange: {
      handler() {
        this.updatefilterInQueryString();
      },
      deep: true,
    },
  },
  mounted() {
    this.parsefilterFromQueryString();
  },
  methods: {
    parsefilterFromQueryString() {
      if (this.filter === undefined) return;
      if (this.$route.query.filter === null) return;

      let json;
      try {
        json = JSON.parse(this.$route.query.filter);
      } catch {
        json = undefined;
      }
      Object.keys(this.filter).forEach((k) => {
        if (json !== undefined && json[k] !== undefined && json[k] !== null) {
          this.filter[k] = json[k];
        }
      });
      const dateRange = { ...this.$route.query.dateRange };
      if (dateRange && Object.keys(dateRange).length > 1) {
        this.dateRange = [];
        Object.assign(this.dateRange || {}, dateRange);
        [this.filter.startDate, this.filter.endDate] = this.dateRange;
        [this.filter.fromDate, this.filter.toDate] = this.dateRange;
      }
      const tempKeyword = this.$route.query.keyword;
      if (tempKeyword && tempKeyword.length > 0) {
        this.keyword = tempKeyword || '';
      }
    },
    updatefilterInQueryString() {
      if (this.filter === undefined) return;
      const filter = { ...this.filter };
      if (!this.dateRange) {
        delete filter.startDate;
        delete filter.endDate;
        delete filter.fromDate;
        delete filter.toDate;
      }
      Object.keys(this.filter).forEach((k) => {
        if (this.filter[k] === undefined || this.filter[k] === null) {
          delete filter[k];
        }
      });

      const query = {
        ...this.$route.query,
        filter: JSON.stringify(filter),
        keyword: this.keyword,
        dateRange: this.dateRange,
        // ...filter,
      };
      if (Object.keys(filter).length === 0) {
        delete query.filter;
      }
      this.$router.replace({ query }).catch(() => {});
    },
  },
};

export default filtersQueryStringMixin;
